/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSign.vue?vue&type=template&id=1ed346fc&scoped=true"
import script from "./popSign.vue?vue&type=script&lang=js"
export * from "./popSign.vue?vue&type=script&lang=js"
import style0 from "./popSign.vue?vue&type=style&index=0&id=1ed346fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed346fc",
  null
  
)

export default component.exports